import { inject, Injectable } from '@angular/core';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { environment } from '../../../../../../environments/environment';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { DeleteDocumentRequest } from '../maintenance-attachments-interface/maintenance-attachments.interface';
import { GetAllDocumentsResponse, AdditionalDocumentsRequest } from '../maintenance-attachments-models/maintenance-attachments.models';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceAttachmentsService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  //upload
  async uploadDocuments(formData: FormData) {
    const API_URL: string = environment.baseUrl + environment.apis.uploadnewapplicationDocument;

    formData.append(
      'UpdateByRole',
      this.sessionStorageService.getCurrentUserRole()
    );

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Authorization':
          this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: formData
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(
          error.response?.data,
          error.status
        );
      });
  }

  //delete
  async deleteDocument(data: DeleteDocumentRequest) {
    const API_URL: string = environment.baseUrl + environment.apis.deletedocument;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: data
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => JSON.stringify(httpResponse))
      .catch((error) => {
        throw new AxiosError(error.response?.data, error.status);
      });
  }

  //view
  async viewApplicationDetails(viewid: number) {
    const API_URL: string = environment.baseUrl + environment.apis.viewApplicationDetails;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "id": viewid
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  //view additional documents
  async getAdditionalDocuments(piasRepCode: string) {
    const API_URL: string = environment.baseUrl + environment.apis.additionaldocument;
    const payload = new AdditionalDocumentsRequest({
      pias_rep_code: piasRepCode,
      updated_by_role: ['NEWREP', 'DSU', 'DSU Manager']
    });

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: payload.toJson()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response?.data, error.status);
      });
  }

} 